module.exports = __webpack_public_path__ + "img/tc.51a636c3.svg";